import { createAction } from '@reduxjs/toolkit';
import type { Annotator, AnnotatorTypes, API, ErrorObject, UUID } from 'types';

export const fetchAllAnnotators = createAction<{
  name?: string;
  limit?: string;
  searchValue?: string;
}>('ANNOTATORS/FETCH');
export const fetchAllAnnotatorsRequest = createAction('ANNOTATORS/FETCH_REQUEST');
export const fetchAllAnnotatorsSuccess = createAction<API.WrappedAPIResponse<Annotator>>(
  'ANNOTATORS/FETCH_SUCCESS'
);
export const fetchAllAnnotatorsSuccessAppend = createAction<API.WrappedAPIResponse<Annotator>>(
  'ANNOTATORS/FETCH_SUCCESS_APPEND'
);
export const fetchAllAnnotatorsFailure = createAction<ErrorObject>('ANNOTATORS/FETCH_FAILURE');

export const fetchAnnotatorTypes = createAction('ANNOTATORS/FETCH_TYPES');
export const fetchAnnotatorTypesRequest = createAction('ANNOTATORS/FETCH_TYPES_REQUEST');
export const fetchAnnotatorTypesSuccess = createAction<AnnotatorTypes>(
  'ANNOTATORS/FETCH_TYPES_SUCCESS'
);
export const fetchAnnotatorTypesFailure = createAction<ErrorObject>(
  'ANNOTATORS/FETCH_TYPES_FAILURE'
);

export type UpsertAnnotatorPayload = {
  annotatorId?: UUID;
  // eslint-disable-next-line camelcase
  options_config: AnnotatorTypes[string]['options'];
  showSuccess?: boolean;
  name?: string;
  description?: string | null;
  // eslint-disable-next-line camelcase
  always_save?: boolean;
  redirect?: boolean;
  type?: string;
  ruleId?: string;
  campaignId?: string;
};

export type FetchAnnotatorChangelogType = {
  annotatorId: UUID;
  auditlogUuid: UUID;
  version: string;
};

export const fetchAnnotatorChangelog = createAction<FetchAnnotatorChangelogType>(
  'ANNOTATOR/FETCH_CHANGELOG'
);

export type ReplaceAnnotatorType = {
  source: UUID;
  targets: UUID[];
};
